const save = (slideId, controller) => {
  const target = document.querySelector(`#page-thumb-container-with-index-${slideId}`);
  if (!target) return false;

  return controller.stimulate('Slide#update_via_frontend', target);
};

export default save;
